import { FC } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { FILTER_DATE } from "../../../constants/filter-types";
import { REPORTS_TRANSACTION_TIME_ATTENDANCE } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { DEF_PG_SIZE_REPORTS } from '../../../constants/maximum-page-size';
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import TnaTransactionColumn from "../../../models/ColumnDefinitions/TnaTransactionColumn";
import { Filter } from "../../../models/Filter";
import { ListQuery } from "../../../models/ListQuery";
import TnaTransactionSearch from "../../../models/search/TnaTransactionSearch";
import { auditRunReport } from "../../../services/auditService";
import { getTimeAttendanceTransactionReport } from "../../../services/reportService";
import { getUserFiltersByView } from "../../../services/userPreferenceService";
import { getTodayDate } from "../../../utilities/DateUtils";

interface RptProps {
    reportId: string;
}

const TimeAttendanceTransactionReport: FC<RptProps> = ({ reportId }) => {
    const { translate } = useLocale();

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_TRANSACTION_TIME_ATTENDANCE;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, customFilter, reportId, staticFilterKeys) => void) => {
        // Filters that should always show for this view
        const staticFilterKeys = ["dateOnly"];

        //Add custom filter
        let customFilter: Filter[] = [];
        getUserFiltersByView(userLoginId, currentMenuDetail, reportId).then((response) => {
            const dateFilter = response.find(filter => filter.filterId === FILTER_DATE);
            if (!!!dateFilter) {
                customFilter = [{
                    isCustomFilter: true,
                    isStatic: true,
                    clearPolicy: "locked",
                    key: "dateOnly",
                    label: translate.byKey(TranslationKeys.date),
                    options: [],
                    selected: [{
                        label: getTodayDate(true),
                        value: getTodayDate(false)
                    }]
                }];
            }
        }).catch((error) => {
            console.log("Failed to load user preferences")
        }).finally(() => {
            setDetails(userLoginId, currentMenuDetail, customFilter, reportId, staticFilterKeys);
        })
    }
    // <-- end context

    const getDataMethod = async (listParameters?: ListQuery) => {
        try {
            await auditRunReport(reportId);
            return getTimeAttendanceTransactionReport(listParameters);
        } catch (error) {
            return Promise.reject(error);
        }
    }

    return (<TableContextProvider
        maxPageSize={DEF_PG_SIZE_REPORTS}
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={TnaTransactionColumn}
        searchDescriptor={TnaTransactionSearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        loadDataOnDemand
        runDataOnDemandButtonLabel={translate.byKey(TranslationKeys.runReport)}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.timeAndAttendance)}
            selectRows={false}
            showFilterMenu={true}
            cyName="timeAndAttendanceTransactionReports"/>
    </TableContextProvider >
    );
};

export default TimeAttendanceTransactionReport;

